import EUBlockedContent from './eu-blocked-content'

export default EUBlockedContent
